import axiosConfig from './axiosConfig';

const apiRateGroup = {
   list: (filter) => axiosConfig.requests.get(`/RateGroup/ListRateGroups?PageNumber=${filter.pageNumber}&PageSize=${filter.pageSize}`),
   filterListDM: {
      pageNumber: 1,
      pageSize: 99999,
      sName: '',
      sDescription: '',
      dExpiredDate: '',
      bActive: true,
      bLockChanges: true,
      bNotDisplay: true,
   },
   details: (id) => axiosConfig.requests.get(`/RateGroup/${id}`),
   create: (group) => axiosConfig.requests.post('/RateGroup', group),
   update: (group) => axiosConfig.requests.put(`/RateGroup/${group.id}`, group),
   delete: (id) => axiosConfig.requests.del(`/RateGroup/${id}`),
};

export default { apiRateGroup };
